// extracted by mini-css-extract-plugin
export var arrows = "_23-6";
export var decrementer = "_23-a";
export var disabled = "_23-4";
export var error = "_23-1";
export var hiddenText = "_23-b";
export var incrementer = "_23-9";
export var input = "_23-8";
export var inputWrapper = "_23-0";
export var leadingIcon = "_23-c";
export var readonly = "_23-3";
export var regular = "_23-7";
export var small = "_23-5";
export var warning = "_23-2";